import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    departmentId: Yup.string().required('Required').nullable(),
  });